import apiAuctionsOPL from '../../api/apiAuctionsOPL'
const state = {
    brands: [],
    serverBrands: [],
    brandLabels: [],
    chassis: [],
    types: [],
    models: [],
    serverModels: [],
    activeTypeIndex: '',
    search: '',
    activeWeekday: '',
    auctions: [],
    regions: [],
    selectedRegions: [],
    query: {
        brand: '',
        'models': [],
        'grades': [],
        yearMin: 1970,
        yearMax: new Date().getFullYear(),
        kmsMin: null,
        kmsMax: null,
        priceMin: null,
        priceMax: null,
        ccMin: null,
        ccMax: null,
        date: null,
        'dates': [],
        carGrade: null,
        'chassis': [],
        'transmissions': [],
        'lots': [],
        'colors': [],
        'equipment': [],
        'auctions': [],
        'regions' : [],
        order_column: 'lot_date',
        order_type: 'DESC',
        page: 1,
        auctionType: 0,
    }
}

const getters = {
    getAllBrandsOPL: (state) => {
        return state.brands
    },
    topJapaneseBrandsOPL: state => {
        return state.brands.filter(b => {
            if ( b.top && b.country === "Japan" ) return b
        })
    },
    topOtherBrandsOPL: state => {
        return state.brands.filter(b => {
            if ( b.top && b.country !== "Japan" ) return b
        })
    },
    getJapaneseBrandsOPL: state => {
        return state.serverBrands.filter(b => {
            if (b.country === "JAPAN" ) return b
        })
    },
    getOtherBrandsOPL: state => {
        return state.serverBrands.filter(b => {
            if (b.country !== "JAPAN" ) return b
        })
    },
    getAllChassisOPL: (state) => {
        return state.chassis
    },
    getQueryChassisOPL: (state) => {
        return state.query["chassis"]
    },
    getQueryChassisByChassisOPL: state => chassis => {
        return state.query['chassis'].filter(m => m === chassis)
    },
    getResultOrderColumnOPL: (state) => {
        return state.query.order_column
    },
    getResultOrderTypeOPL: (state) => {
        return state.query.order_type
    },
    getQueryOPL: state => {
        return state.query
    },
    getQueryAuctionByIdOPL: state => auction => {
        return state.query['auctions'].filter(a => a === auction)
    },
    getQueryModelsByModelOPL: state => model => {
        return state.query['models'].filter(m => m === model)
    },
    getQueryCompanyIdOPL: state => {
        return state.query.brand
    },
    getQueryModelsOPL: state => {
        return state.query.models
    },
    getBrandCarsByCountryOPL: (state) => (country) => {
        return state.brands.filter(b => b.country === country)
    },
    getBrandLabelsOPL: (state) => {
        return state.brandLabels
    },
    getModelTypesOPL: (state) => {
        return state.types
    },
    getActiveTypeOPL: (state) => {
        return state.activeTypeIndex
    },
    getModelsOPL: (state) => {
        if (state.search) {
            return state
                .models
                .filter(m => m.name.toLowerCase().includes(state.search.toLowerCase()))
        } else {
            return state.models
        }
    },
    getServerModelsOPL: (state) => {
        return state.serverModels
    },
    getActiveModelsOPL: (state) => {
        if (state.search) {
            return state
                .models
                .filter(m => m.name.toLowerCase().includes(state.search.toLowerCase()))
        } else {
            const type = state.types[state.activeTypeIndex]
            return state.models.filter(m => m.type === type)
        }
    },
    getActiveWeekdayOPL: (state) => {
        return state.activeWeekday
    },
    getAuctionsOPL: (state) => {
        return state.auctions
    },
    getAuctionsByRegionOPL: (state) => (region) => {
        return state.auctions.filter(a => {
            if (a.region === region && a.day === state.activeWeekday) return a
        })
    },
    getAllAuctionsByRegionOPL: (state) => (region) => {
        return state.auctions.filter(a => {
            if (a.region === region) return a
        })
    },
    getRegionsOPL: (state) => {
        return state.regions
    },
    getAuctionsByDayOPL: (state) => {
        return state.auctions.filter(a => a.day === state.activeWeekday)
    },
    getAuctionSearchQueryOPL: (state) => {
        return state.query
    },
    getQueryYearMinOPL: (state) => {
        return state.query.yearMin
    },
    getQueryYearMaxOPL: (state) => {
        return state.query.yearMax
    },
    getQueryKmMinOPL: (state) => {
        return state.query.kmsMin
    },
    getQueryKmMaxOPL: (state) => {
        return state.query.kmsMax
    },
    getQueryPriceMinOPL: (state) => {
        return state.query.priceMin
    },
    getQueryPriceMaxOPL: (state) => {
        return state.query.priceMax
    },
    getQueryCCMinOPL: (state) => {
        return state.query.ccMin
    },
    getQueryCCMaxOPL: (state) => {
        return state.query.ccMax
    },
    getQueryCarGradeOPL: (state) => {
        return state.query.carGrade
    },
    getQueryTransmissionStatusOPL: (state) => (transmission) => {
        return state.query["transmissions"]
            .filter(t => t === transmission).length !== 0
    },
    getQueryAuctionGradeStatusOPL: (state) => (grade) => {
        return state.query["grades"]
            .filter(g => g === grade).length !== 0
    },
    getQueryEquipmentStatusOPL: (state) => (equipment) => {
        return state.query["equipment"]
            .filter(eq => eq === equipment).length !== 0
    },
    getQueryLotsOPL: (state) => {
        return state.query["lots"]
    },
    getQueryColorStatusOPL: (state) => (color) => {
        return state.query["colors"].filter(c => c === color).length !== 0
    },
    getQueryLotDateOPL: (state) => {
        return state.query['date']
    },
    getQueryRegionsOPL: (state) => {
        return state.query['regions']
    },
    getQueryAuctionsOPL: (state) => {
        return state.query['auctions']
    },
    getAuctionTypeOPL: (state) => {
        return state.query["auctionType"]
    },
    getQueryDatesByDateOPL: state => date => {
        return state.query['dates'].filter(m => m === date)
    },
    getQueryAuctionsHasRegionOPL: (state) => (region) =>  {
        let auctions = [];

        for(let auction in state.auctions){
            for(let filter in state.query['auctions']){

                if(state.auctions[auction].id === state.query['auctions'][filter]){
                    auctions.push(state.auctions[auction]);
                }
            }
        }

        let found = false;

        for(let i = 0; i < auctions.length; i++) {
            if (auctions[i].region === region) {
                found = true;
                break;
            }
        }

        return found
    }
}

// TODO 1. on brand change clear query params
// TODO 2. on Auctions click make new query object
const actions = {
    fetchBrandsFromServerOPL: ({ commit }) => {
        apiAuctionsOPL
            .getCarMarkas()
            .then((response) => {
                commit('mutateServerBrandsOPL', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchBrandsOPL: ({ commit }) => {
        commit('mutateBrandsOPL', apiAuctionsOPL.getCarBrands())
    },
    fetchBrandLabelsOPL: ({ commit }) => {
        commit('mutateBrandLabelsOPL', apiAuctionsOPL.getCarBrandLabels())
    },
    fetchBrandModelsOPL: ({ commit, dispatch }, brandId) => {
        dispatch('setStatusLoading')
        apiAuctionsOPL.getBrandModels(brandId)
            .then((response) => {
                commit('mutateBrandModelsAndTypesOPL', response.data)
                dispatch('setStatusLoaded')
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchBrandModelsByBrandIdOPL: ({ commit, dispatch}, brandId) => {
        dispatch('setStatusLoading')
        apiAuctionsOPL
            .getModelsByBrandId(brandId)
            .then((response) => {
                commit('mutateServerModelsOPL', response.data)
                dispatch('setStatusLoaded')
            })
            .catch((error) => {
                console.log(error)
            })
    },
    fetchAllChassisByModelNameOPL: ({ commit }, modelName) => {
        apiAuctionsOPL
            .getChassisByModelName(modelName)
            .then((response) => {
                commit('mutateChassisOPL', response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    removeChassisFromQueryOPL: ({ commit }, model) => {
        commit('removeChassisFromQueryOPL', model)
    },
    handleQueryChassisOPL: ({ commit }, value) => {
        commit('handleQueryChassisOPL', value)
    },
    setBrandModelToDefaultOPL: ({ commit }) => {
        commit('setQueryCompanyIdOPL', '')
        commit('handleQueryModelsOPL', [])
    },
    setChassisToDefaultOPL: ({ commit }) => {
        commit('mutateChassisOPL', [])
        commit('resetChassisQueryOPL')
    },
    resetChassisQueryOPL: ({ commit }) => {
        commit('resetChassisQueryOPL')
    },
    setChassisQueryOPL: ({ commit }, chassis) => {
        commit('setChassisQueryOPL', chassis)
    },
    addAuctionToQueryAdvanceFilterOPL: ({commit}, newValue) => {
        commit('pushAuctionToQueryAdvanceFilterOPL', newValue)
    },
    setResultOrderColumnOPL: ({ commit }, newValue) => {
        commit('mutateResultOrderColumnOPL', newValue)
    },
    setResultOrderTypeOPL: ({ commit }, newValue) => {
        commit('mutateResultOrderTypeOPL', newValue)
    },
    fetchAuctionsDataOPL: ({ commit , dispatch}) => {
        dispatch('setStatusLoading')
        apiAuctionsOPL.getAuctionsData()
            .then((response) => {
                commit('changeAuctionsOPL', response.data.auctions)
                commit('changeRegionsOPL', response.data.regions)
                dispatch('setStatusLoaded')
            })
            .catch((error) => console.log(error))
    },
    changeActiveElementOPL: ({ commit }, newElementIndex) => {
        commit('changeActiveElementOPL', newElementIndex)
    },
    changeActiveWeekdayOPL: ({ commit }, value) => {
        commit('changeActiveWeekdayOPL', value)
    },
    changeModelSearchValueOPL: ({commit}, value) => {
        commit('changeSearchValueOPL', value)
    },
    changeQueryCompanyIdOPL: ({ commit }, value) => {
        commit('setQueryCompanyIdOPL', value)
    },
    addModelToQueryOPL: ({ commit }, model) => {
        commit('addModelToQueryOPL', model)
    },
    removeModelFromQueryOPL: ({ commit }, model) => {
        commit('removeModelFromQueryOPL', model)
    },
    removeModelsOPL: ({ commit }) => {
        commit('removeModelsOPL')
    },
    removeLotFromQueryOPL: ({ commit }, model) => {
        commit('removeLotFromQueryOPL', model)
    },
    addAuctionToQueryOPL: ({ commit }, auction) => {
        commit('addAuctionToQueryOPL', auction)
    },
    removeAuctionFromQueryOPL: ({ commit }, auction) => {
        commit('removeAuctionFromQueryOPL', auction)
    },
    addAllAuctionsByRegionOPL: ({ commit, getters }, region) => {
        const auctions = getters.getAuctionsByRegionOPL(region).map(a => a.id)
        commit('handleAuctionsQueryOPL', auctions)
    },
    addAllAuctionsByRegionForAllDaysOPL: ({ commit, getters }, region) => {
        const auctions = getters.getAllAuctionsByRegionOPL(region).map(a => a.id)
        commit('handleAuctionsQueryOPL', auctions)
    },
    addAllAuctionsByActiveDayOPL: ({ commit, getters }) => {
        const auctions = getters.getAuctionsByDayOPL.map(a => a.id)
        commit('handleAuctionsQueryOPL', auctions)
    },
    addNewYearRangeMinValueOPL: ({ commit }, value) => {
        commit('changeYearRangeMinOPL', value)
    },
    addNewYearRangeMaxValueOPL: ({ commit }, value) => {
        commit('changeYearRangeMaxOPL', value)
    },
    addNewKmRangeMinValueOPL: ({ commit }, value) => {
        commit('changeKmRangeMinOPL', value)
    },
    addNewKmRangeMaxValueOPL: ({ commit }, value) => {
        commit('changeKmRangeMaxOPL', value)
    },
    addNewPriceRangeMinValueOPL: ({ commit }, value) => {
        commit('changePriceRangeMinOPL', value)
    },
    addNewPriceRangeMaxValueOPL: ({ commit }, value) => {
        commit('changePriceRangeMaxOPL', value)
    },
    addNewCCRangeMinValueOPL: ({ commit }, value) => {
        commit('changeCCRangeMinOPL', value)
    },
    addNewCCRangeMaxValueOPL: ({ commit }, value) => {
        commit('changeCCRangeMaxOPL', value)
    },
    addNewCarGradeOPL: ({ commit }, value) => {
        commit('changeCarGradeOPL', value)
    },
    handleQueryTransmissionOPL: ({ commit }, value) => {
        commit('handleQueryTransmissionOPL', value)
    },
    handleQueryGradesOPL: ({ commit }, value) => {
        commit('handleQueryGradesOPL', value)
    },
    handleQueryEquipmentOPL: ({ commit }, value) => {
        commit('handleQueryEquipmentOPL', value)
    },
    handleQueryLotsOPL: ({ commit }, value) => {
        commit('handleQueryLotsOPL', value)
    },
    handleQueryModelsOPL: ({ commit }, value) => {
        commit('handleQueryModelsOPL', value)
    },
    handleQueryColorOPL: ({ commit }, value) => {
        commit('handleQueryColorOPL', value)
    },
    setQueryToDefaultOPL: ({commit}) => {
        commit('setDefaultAuctionQueryOPL')
    },
    handleNewLotDateOPL: ({commit}, value) => {
        commit('handleLotDateQueryOPL', value)
    },
    setQueryToNewValueOPL: ({commit}, value) => {
        commit('changeQueryOPL', value)
    },
    addSelectedRegionOPL: ({commit}, value) => {
        commit('pushSelectedRegionOPL', value)
    },
    removeSelectedRegionOPL: ({commit}, value) => {
        commit('filterSelectedRegionOPL', value)
    },
    setAuctionTypeOPL: ({commit}, value) => {
        commit('changeAuctionTypeOPL', value)
    },
    setModelsToDefaultOPL: ({commit}) => {
        commit('mutateBrandModelsAndTypesOPL', { models: [], types: [] })
    },
    addDateToQueryOPL: ({ commit }, date) => {
        commit('pushDateToQueryOPL', date)
    },
    removeDateFromQueryOPL: ({ commit }, date) => {
        commit('filterDateFromQueryOPL', date)
    },
    setSearchQueryPageNumberOPL: ({commit}, value) => {
        commit('updatePageNumberOPL', value)
    }

}

const mutations = {
    mutateChassisOPL: (state, value) => {
        state.chassis = value
    },
    handleQueryChassisOPL: (state, value) => {
        state.query["chassis"].push(value)
    },
    removeChassisFromQueryOPL: (state, chassis) => {
        state.query['chassis'] = state.query['chassis'].filter(m => m !== chassis)
    },
    resetChassisQueryOPL: (state) => {
        state.query['chassis'] = []
    },
    setChassisQueryOPL: (state, chassis) => {
        state.query['chassis'] = chassis
    },
    mutateServerModelsOPL: (state, value) => {
        state.serverModels = value
    },
    filterSelectedRegionOPL: (state, value) => {
        state.selectedRegions = state.selectedRegions.filter(m => m !== value)
    },
    pushSelectedRegionOPL: (state, newValue) => {
        state.query['regions'] = newValue
    },
    mutateResultOrderColumnOPL: (state, newValue) => {
        state.query.order_column = newValue
    },
    mutateResultOrderTypeOPL: (state, newValue) => {
        state.query.order_type = newValue
    },
    updatePageNumberOPL: (state, pageNumber) => {
        state.query.page = pageNumber
    },
    mutateBrandsOPL: (state, newBrands) => {
        state.brands = newBrands
    },
    mutateServerBrandsOPL: (state, newBrands) => {
        state.serverBrands = newBrands
    },
    mutateBrandLabelsOPL: (state, brands) => {
        state.brandLabels = brands
    },
    mutateBrandModelsAndTypesOPL: (state, data) => {
        state.models = data.models
        state.types = data.types
    },
    changeActiveElementOPL: (state, newElementIndex) => {
        state.activeTypeIndex = newElementIndex
    },
    changeSearchValueOPL: (state, value) => {
        state.search = value
    },
    changeActiveWeekdayOPL: (state, value) => {
        state.activeWeekday = value
    },
    changeAuctionsOPL: (state, data) => {
        state.auctions = data
    },
    changeRegionsOPL: (state, data) => {
        state.regions = data
    },
    setQueryCompanyIdOPL: (state, companyId) => {
        state.query.brand = companyId
    },
    addModelToQueryOPL: (state, model) => {
        state.query['models'].push(model)
    },
    removeModelFromQueryOPL: (state, model) => {
        state.query['models'] = state.query['models'].filter(m => m !== model)
    },
    removeModelsOPL: (state) => {
        state.query['models'] = []
    },
    removeLotFromQueryOPL: (state, lots) => {
        state.query['lots'] = state.query['lots'].filter(m => m !== lots)
    },
    addAuctionToQueryOPL: (state, auction) => {
        state.query['auctions'].push(auction)
    },
    removeAuctionFromQueryOPL: (state, auction) => {
        state.query['auctions'] = state.query['auctions'].filter(a => a !== auction)
    },
    handleAuctionsQueryOPL: (state, auctions) => {
        // TODO check containers exisitngCount > newCount, existingCount == newCount, existingCoung == 0
        const existing = state.query['auctions']
        if ( existing.length === 0 ) {
            state.query['auctions'] = auctions
        } else {
            const filterExisting = existing.filter(ex => !auctions.includes(ex))
            const filterNewAuctions = auctions.filter(ex => !existing.includes(ex))
            state.query['auctions'] = filterExisting.concat(filterNewAuctions)
        }
    },
    changeYearRangeMinOPL: (state, newValue) => {
        state.query.yearMin = newValue
    },
    changeYearRangeMaxOPL: (state, newValue) => {
        state.query.yearMax = newValue
    },
    changeKmRangeMinOPL: (state, newValue) => {
        state.query.kmsMin = newValue
    },
    changeKmRangeMaxOPL: (state, newValue) => {
        state.query.kmsMax = newValue
    },
    changePriceRangeMinOPL: (state, newValue) => {
        state.query.priceMin = newValue
    },
    changePriceRangeMaxOPL: (state, newValue) => {
        state.query.priceMax = newValue
    },
    changeCCRangeMinOPL: (state, newValue) => {
        state.query.ccMin = newValue
    },
    changeCCRangeMaxOPL: (state, newValue) => {
        state.query.ccMax = newValue
    },
    changeCarGradeOPL: (state, newValue) => {
        state.query.carGrade = newValue
    },
    handleLotDateQueryOPL: (state, newValue) => {
        state.query.date = newValue
    },
    handleQueryTransmissionOPL: (state, value) => {
         if (state.query["transmissions"].filter(t => t === value).length === 0)  {
             state.query["transmissions"].push(value)
         } else {
             state.query["transmissions"] = state.query["transmissions"].filter(t => t !== value)
         }
    },
    handleQueryGradesOPL: (state, value) => {
        if (state.query["grades"].filter(g => g === value).length === 0)  {
            state.query["grades"].push(value)
        } else {
            state.query["grades"] = state.query["grades"].filter(g => g !== value)
        }
    },
    handleQueryEquipmentOPL: (state, value) => {
        if (state.query["equipment"].filter(eq => eq === value).length === 0)  {
            state.query["equipment"].push(value)
        } else {
            state.query["equipment"] = state.query["equipment"].filter(eq => eq !== value)
        }
    },
    handleQueryLotsOPL: (state, value) => {
        state.query["lots"].push(value)
    },
    handleQueryModelsOPL: (state, value) => {
        state.query["models"] = value
    },
    handleQueryColorOPL: (state, value) => {
        if (state.query["colors"].filter(c => c === value).length === 0)  {
            state.query["colors"].push(value)
        } else {
            state.query["colors"] = state.query["colors"].filter(c => c !== value)
        }
    },
    setDefaultAuctionQueryOPL: (state) => {
        const defaultQ = {
            brand: '',
            'models': [],
            'grades': [],
            yearMin: 1970,
            yearMax: new Date().getFullYear(),
            kmsMin: null,
            kmsMax: null,
            priceMin: null,
            priceMax: null,
            ccMin: null,
            ccMax: null,
            date: null,
            'dates': [],
            carGrade: null,
            'chassis': [],
            'transmissions': [],
            'lots': [],
            'colors': [],
            'equipment': [],
            'auctions': [],
            'regions': [],
            order_column: 'lot_date',
            order_type: 'DESC',
            page: 1,
            auctionType: 0
        }
        state.query = Object.assign({}, defaultQ)
    },
    changeQueryOPL: (state, value) => {
        state.query = value
    },
    pushAuctionToQueryAdvanceFilterOPL: (state, value) => {
        state.query['auctions'] = value
    },
    changeAuctionTypeOPL: (state, value) => {
        state.query['auctionType'] = value
    },
    pushDateToQueryOPL: (state, date) => {
        state.query['dates'].push(date)
    },
    filterDateFromQueryOPL: (state, date) => {
        state.query['dates'] = state.query['dates'].filter(m => m !== date)
    },


}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/onePriceList.js